import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '../styles';
import { RequiredBadge } from './required_badge';
export const InputButtonTypeCheckbox = (props) => {
    const { classObject, items, currentValue, label, isHalfTile, setCurrentValue, onClickButton } = props;
    const onClick = (value) => {
        if (onClickButton) {
            onClickButton(value);
            return;
        }
        let values;
        if (currentValue.includes(value)) {
            values = currentValue.filter((v) => v !== value);
        }
        else {
            values = [...currentValue, value];
        }
        setCurrentValue(values);
    };
    return (React.createElement("div", { className: css(styles.container, classObject) },
        label && (React.createElement("div", { className: css(styles.label) },
            label,
            props.required && React.createElement(RequiredBadge, null))),
        React.createElement("div", { className: css(styles.checkboxContainer) }, items.map(({ name, value }, index) => (React.createElement("div", { className: css(styles.checkbox, isHalfTile && (index !== items.length - 1 || items.length % 2 === 0)
                ? styles.itemWrapHalf
                : styles.itemWrapFull, currentValue.includes(value) ? styles.checkboxOn : styles.checkboxOff, props.hasValidationError && styles.validationError), onClick: () => onClick(value), key: index },
            React.createElement("div", { className: css(styles.name) }, name))))),
        props.validationErrorMessage && (React.createElement("div", { className: css(styles.validationErrorMessage) }, props.validationErrorMessage))));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    checkboxContainer: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
    },
    itemWrapFull: {
        width: '100%',
        boxSizing: 'border-box',
    },
    itemWrapHalf: {
        width: 'calc((100% - 8px) / 2)',
        boxSizing: 'border-box',
    },
    label: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        color: Colors.GrayDarkest,
        fontSize: 14,
        marginBottom: 8,
    },
    checkbox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 50,
        width: '100%',
        boxSizing: 'border-box',
        borderRadius: 4,
        cursor: 'pointer',
    },
    checkboxOn: {
        color: Colors.White,
        backgroundColor: Colors.PrimaryDark,
        border: `1px solid ${Colors.PrimaryDark}`,
    },
    checkboxOff: {
        color: Colors.GrayDarkest,
        border: `1px solid ${Colors.Gray}`,
    },
    name: {
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'center',
        padding: '4px 6px',
    },
    validationError: {
        border: `1px solid ${Colors.Alert}`,
    },
    validationErrorMessage: {
        marginTop: 4,
        color: Colors.Alert,
        fontSize: 12,
        fontWeight: 400,
        lineHeight: '160%',
        letterSpacing: 0.48,
    },
});
